import PropTypes from 'prop-types'
import { memo } from 'react'

import { APP_HREF } from '../../../../config'
import { Label } from '../../../Label'
import { Ticks } from '../../../Ticks'
import * as LABELS from '../../config/labels'
import { renderValue } from '../../lib/helpers'

import * as S from './styles'

export const ResultRenegotiationMain = memo(
  ({ savings, creditCost, isOverlayVisible, onClickButton, payment, rate, ticks, isEmpty, ...props }) => {
    const secondaryLabels = [
      ['SAVINGS', savings],
      ['NEW_RATE', rate],
      ['CREDIT_COST', creditCost],
    ]

    const { suffix, ...labelRenegotiation } = LABELS.RENEGOTIATION

    const negativeProfits = savings < 0

    return (
      <S.Card {...props}>
        <S.Overlay $isVisible={isOverlayVisible}>
          <S.SvgArrowTablet width="15" height="81" viewBox="0 0 15 81" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.29289 6.65685L6.65685 0.292892C7.04737 -0.0976337 7.68054 -0.0976337 8.07106 0.292892L14.435 6.65685C14.8256 7.04738 14.8256 7.68054 14.435 8.07107C14.0445 8.46159 13.4113 8.46159 13.0208 8.07107L7.94974 2.99999L6.77817 2.99999L1.7071 8.07107C1.31658 8.46159 0.683415 8.46159 0.29289 8.07107C-0.0976343 7.68054 -0.0976343 7.04738 0.29289 6.65685ZM8.36396 79L8.36396 81L6.36396 81L6.36396 79L8.36396 79ZM8.36396 71L8.36396 75L6.36396 75L6.36396 71L8.36396 71ZM8.36396 63L8.36396 67L6.36396 67L6.36396 63L8.36396 63ZM8.36396 55L8.36396 59L6.36396 59L6.36396 55L8.36396 55ZM8.36396 47L8.36396 51L6.36396 51L6.36396 47L8.36396 47ZM8.36396 39L8.36396 43L6.36396 43L6.36396 39L8.36396 39ZM8.36396 31L8.36396 35L6.36396 35L6.36396 31L8.36396 31ZM8.36396 23L8.36396 27L6.36396 27L6.36396 23L8.36396 23ZM8.36396 15L8.36396 19L6.36396 19L6.36396 15L8.36396 15ZM8.36396 7L8.36396 11L6.36396 11L6.36396 7L8.36396 7Z"
            />
          </S.SvgArrowTablet>
          <S.SvgArrowDesktop
            width="105"
            height="69"
            viewBox="0 0 105 69"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.792893 8.70705C0.402369 8.31653 0.402369 7.68336 0.792893 7.29284L7.15685 0.92888C7.54738 0.538355 8.18054 0.538355 8.57107 0.92888C8.96159 1.3194 8.96159 1.95257 8.57107 2.34309L3.54567 7.3685L3.5385 8.62423L8.57107 13.6568C8.96159 14.0473 8.96159 14.6805 8.57107 15.071C8.18054 15.4615 7.54738 15.4615 7.15685 15.071L0.792893 8.70705ZM11.5646 9.15047C10.2404 9.10916 8.89636 9.07644 7.53195 9.05221L7.56746 7.05252C8.94051 7.07691 10.2935 7.10984 11.627 7.15144L11.5646 9.15047ZM19.5849 9.52162C18.2727 9.43967 16.9392 9.36757 15.5839 9.30517L15.6759 7.30729C17.0417 7.37017 18.3861 7.44286 19.7096 7.52551L19.5849 9.52162ZM27.5735 10.1693C26.2628 10.0367 24.9288 9.91575 23.5708 9.8062L23.7316 7.81268C25.1026 7.92328 26.4501 8.04548 27.7748 8.17945L27.5735 10.1693ZM35.5344 11.1603C34.2365 10.9659 32.9133 10.7851 31.564 10.6177L31.8102 8.63294C33.1756 8.80232 34.5155 8.98537 35.8306 9.18233L35.5344 11.1603ZM43.4061 12.5713C42.1262 12.3008 40.8187 12.0462 39.483 11.8075L39.8348 9.83873C41.1904 10.081 42.5185 10.3395 43.8198 10.6146L43.4061 12.5713ZM51.1511 14.501C49.8967 14.1366 48.6128 13.7912 47.2982 13.4646L47.7804 11.5236C49.1195 11.8563 50.4287 12.2084 51.7091 12.5804L51.1511 14.501ZM58.6937 17.06C57.4789 16.5826 56.2327 16.1276 54.954 15.6948L55.5951 13.8003C56.9034 14.2431 58.1797 14.7091 59.4253 15.1987L58.6937 17.06ZM65.9203 20.356C64.7643 19.7479 63.5763 19.1661 62.3548 18.61L63.1834 16.7897C64.4388 17.3612 65.6609 17.9598 66.8513 18.5859L65.9203 20.356ZM72.6957 24.4676C71.6196 23.7178 70.5124 22.9976 69.3724 22.3066L70.4092 20.5963C71.5851 21.3091 72.7278 22.0524 73.8391 22.8267L72.6957 24.4676ZM78.8886 29.4122C77.9125 28.5226 76.9082 27.6652 75.8739 26.8394L77.1218 25.2765C78.1903 26.1296 79.2277 27.0153 80.2358 27.934L78.8886 29.4122ZM84.3995 35.1147C83.5348 34.102 82.6461 33.1225 81.7317 32.1755L83.1704 30.7863C84.1138 31.7632 85.0298 32.773 85.9204 33.8159L84.3995 35.1147ZM89.209 41.4374C88.4561 40.3294 87.684 39.2539 86.8913 38.2101L88.4841 37.0005C89.2988 38.0732 90.0912 39.1773 90.8632 40.3132L89.209 41.4374ZM93.3704 48.226C92.717 47.0476 92.049 45.8998 91.365 44.7819L93.0709 43.738C93.7705 44.8813 94.4529 46.0539 95.1195 47.2561L93.3704 48.226ZM96.9799 55.3497C96.4103 54.1229 95.83 52.9243 95.2378 51.7533L97.0225 50.8507C97.6253 52.0426 98.2154 53.2614 98.7939 54.5074L96.9799 55.3497ZM100.139 62.7029C99.6372 61.4441 99.1277 60.2109 98.6096 59.0029L100.448 58.2145C100.973 59.4391 101.489 60.6882 101.997 61.9622L100.139 62.7029ZM102.277 68.3396C102.046 67.701 101.814 67.0684 101.58 66.4417L103.454 65.7429C103.69 66.3762 103.925 67.0151 104.158 67.6599L102.277 68.3396Z"
            />
          </S.SvgArrowDesktop>
          <S.OverlayContent>Remplissez tous les champs pour voir le résulat</S.OverlayContent>
        </S.Overlay>

        <S.Container>
          <Label {...labelRenegotiation} />

          <S.Highlight $isEmpty={isEmpty}>
            {renderValue(payment)} <S.HighlightSuffix>{suffix}</S.HighlightSuffix>
          </S.Highlight>
        </S.Container>

        {!isEmpty && <S.Status $isError={negativeProfits}>{negativeProfits ? 'Non rentable' : 'Rentable'}</S.Status>}

        <S.Divider />

        <S.Result>
          <ul>
            {secondaryLabels.map(([key, value]) => {
              const { roundTo, suffix, ...labelProps } = LABELS[key]

              return (
                <S.Row key={key}>
                  <Label {...labelProps} />

                  <S.Value $isEmpty={isEmpty}>
                    {renderValue(value, roundTo)} <S.Suffix>{suffix}</S.Suffix>
                  </S.Value>
                </S.Row>
              )
            })}
          </ul>
        </S.Result>

        <S.Button
          href={`${APP_HREF}project/renegotiation/introduction/structure?prefill[maturityType]=unspecified&prefill[simulationType]=renegotiation`}
          onClick={onClickButton}
        >
          Obtenir une estimation avancée
        </S.Button>

        <Ticks ticks={ticks} />
      </S.Card>
    )
  }
)

ResultRenegotiationMain.propTypes = {
  creditCost: PropTypes.number.isRequired,
  isEmpty: PropTypes.bool,
  isOverlayVisible: PropTypes.bool,
  onClickButton: PropTypes.func.isRequired,
  payment: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  savings: PropTypes.number.isRequired,
  ticks: PropTypes.arrayOf(PropTypes.string).isRequired,
}

ResultRenegotiationMain.displayName = 'ResultRenegotiationMain'
